import { render, staticRenderFns } from "./CopyPlayInfo.vue?vue&type=template&id=de004764&scoped=true"
import script from "./CopyPlayInfo.vue?vue&type=script&lang=js"
export * from "./CopyPlayInfo.vue?vue&type=script&lang=js"
import style0 from "./CopyPlayInfo.vue?vue&type=style&index=0&id=de004764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de004764",
  null
  
)

export default component.exports